
<template>
    <div class="floatball" 
        id="floatball" 
        @click="clickon"
        @mousedown="down" 
        @touchstart.stop="down"
        @mousemove="move"
        @touchmove.stop="move" 
        @mouseup="end" 
        @touchend.stop="end" 
        :style="{
            top:position.y + 'px', left:position.x+'px',
            transition: moveFlags ? 'all 700ms ease' : 'unset',
            transform: `translate3d(${transform.left}px,${transform.top}px,0)`,
        }"
        :class="{ 'animat': (moveFlags||firstmove) }"
        >
    </div>
</template>

<script>
    // 鼠标位置和div的左上角位置 差值
    var dx, dy
    var screenWidth = document.documentElement.clientWidth || window.screen.width;
    var screenHeight = document.documentElement.clientHeight || window.screen.height;
    export default {
        data() {
            return {
                flags: false,
                firstmove:true,
                moveFlags: false,
                transform: {
                    top: 0,
                    left: 0,
                },
                position: {
                    x: 325,
                    y: screenHeight -128
                },
            }
        },

        methods: {
            clickon(){
                this.$router.push({path: '/'})
            },
            // 实现移动端拖拽
            down(event) {
                this.flags = true;
                var touch;
                if (event.touches) {
                    touch = event.touches[0];
                } else {
                    touch = event;
                }
                dx = touch.clientX - event.target.offsetLeft
                dy = touch.clientY - event.target.offsetTop
            },
            move() {
                this.firstmove = false
                if (this.flags) {
                    var touch;
                    if (event.touches) {
                        touch = event.touches[0];
                    } else {
                        touch = event;
                    }
                    this.moveFlags = false;
                    // 定位滑块的位置
                    this.position.x = touch.clientX - dx;
                    this.position.y = touch.clientY - dy;
                    // 限制滑块超出页面
                    
                    if (this.position.x < 0) {
                        this.position.x = 0
                    } else if (this.position.x > screenWidth - touch.target.clientWidth) {
                        this.position.x = screenWidth - touch.target.clientWidth
                    }
                    if (this.position.y < 0) {
                        this.position.y = 0
                    } else if (this.position.y > screenHeight - touch.target.clientHeight) {
                        this.position.y = screenHeight - touch.target.clientHeight
                    }
                    event.preventDefault();
                    //阻止页面的滑动默认事件
                    document.addEventListener("touchmove", function () {
                        event.preventDefault();
                    }, false);
                }
            },
            //鼠标释放时候的函数
            end(event) {
                var topcent= (screenHeight-60)/2
                var leftcent= (screenWidth-60)/2
                if(event.target.offsetTop<=topcent&&event.target.offsetLeft<=leftcent){
                    this.moveFlags = true;
                    this.position.y = 60;
                    this.position.x = -10;
                }
                if(event.target.offsetTop<=topcent&&screenWidth-event.target.offsetLeft-60<=leftcent){
                    this.moveFlags = true;
                    this.position.y = 60;
                    this.position.x = screenWidth-50;
                }
                if(event.target.offsetLeft<=leftcent&&screenHeight-event.target.offsetTop-60<=topcent){
                    this.moveFlags = true;
                    this.position.y = screenHeight-128;
                    this.position.x = -10;
                }
                if(screenWidth-event.target.offsetLeft-60<=leftcent&&screenHeight-event.target.offsetTop-60<=topcent){
                    this.moveFlags = true;
                    this.position.y = screenHeight-128
                    this.position.x = screenWidth-50;
                }
                
                this.flags = false;
            },

        }

    }
</script>

<style scoped>
    @keyframes mymove{
        from {opacity :1}
        to {opacity : 0.4}
    }
    .floatball {
        background: #FFFFFF;
        height: 50px;
        width: 50px;
        padding: 5px;
        z-index: 990;
        position: fixed;
        top: 60px;
        right: 325px;
        border-radius: 50%;
        background: url(../../assets/img/icon/goHome.png) no-repeat center;
        background-size: 100%;
    }
    .animat{
        /*animation:mymove 5s infinite;*/
        /*animation-delay:2s;*/

        /*!*Safari and Chrome*!*/
        /*-webkit-animation:mymove 5s;*/
        /*-webkit-animation-delay:2s;*/
        /*animation-fill-mode:forwards;*/
        /*-webkit-animation-fill-mode:forwards;*/
    }
</style>